import { PlanType } from '../config/subscriptionPlans';

const SUBSCRIPTION_KEY = 'GlobalSport_subscription';
const PENDING_AUTH_KEY = 'GlobalSport_pending_auth';
const FAVORITES_KEY = 'GlobalSport_favorites';
const RECENT_SEARCHES_KEY = 'recentSearches';

export interface SubscriptionRecord {
  msisdn: string;
  phoneNumber: string;
  planId: PlanType;
  subscriptionId: string;
  expiresAt: number;
  subscribedAt: number;
}

export interface PendingAuth {
  msisdn: string;
  phoneNumber: string;
  verifiedAt: number;
}

export const savePendingAuth = (msisdn: string, phoneNumber: string): PendingAuth => {
  const pendingAuth: PendingAuth = {
    msisdn,
    phoneNumber,
    verifiedAt: Date.now(),
  };
  localStorage.setItem(PENDING_AUTH_KEY, JSON.stringify(pendingAuth));
  return pendingAuth;
};

export const getPendingAuth = (): PendingAuth | null => {
  const stored = localStorage.getItem(PENDING_AUTH_KEY);
  if (!stored) {
    return null;
  }

  try {
    return JSON.parse(stored) as PendingAuth;
  } catch {
    localStorage.removeItem(PENDING_AUTH_KEY);
    return null;
  }
};

export const clearPendingAuth = (): void => {
  localStorage.removeItem(PENDING_AUTH_KEY);
};

export const saveSubscription = (record: SubscriptionRecord): void => {
  localStorage.setItem(SUBSCRIPTION_KEY, JSON.stringify(record));
};

export const getSubscription = (): SubscriptionRecord | null => {
  const stored = localStorage.getItem(SUBSCRIPTION_KEY);
  if (!stored) {
    return null;
  }

  try {
    const record = JSON.parse(stored) as SubscriptionRecord;
    if (Date.now() > record.expiresAt) {
      clearSubscription();
      return null;
    }
    return record;
  } catch {
    clearSubscription();
    return null;
  }
};

export const clearSubscription = (): void => {
  localStorage.removeItem(SUBSCRIPTION_KEY);
};

export const clearAllUserSession = (): void => {
  clearSubscription();
  clearPendingAuth();
  localStorage.removeItem(FAVORITES_KEY);
  localStorage.removeItem(RECENT_SEARCHES_KEY);
  window.dispatchEvent(new Event('GlobalSport-logout'));
};

export const isSubscriptionActive = (): boolean => getSubscription() !== null;
